// The AI Agent editor's dialogs and activity feed (components/AIAgent), merged into
// the main dictionary under `editor`: t('editor.<key>'). Same keys in en, es and pt.
import rve from './rve/pt.js';
export default {
  // The video editor (components/Editor)
  rve,
  common: {
    cancel: 'Cancelar',
    scene: 'Cena {n}',
    sceneSlide: 'Cena {scene} • Slide {slide}',
    chars: '{n} caracteres',
    unlimited: 'Ilimitado',
    left: 'Restam {remaining} de {limit}',
    inPro: 'Incluído no Pro',
    premiumFeature: 'Recurso premium',
    limitReached: 'Limite atingido',
    upgradePlan: 'Fazer upgrade',
    updateFailed: 'Falha ao atualizar',
    uploadFailed: 'Falha no envio',
    generationFailed: 'Falha ao gerar',
    unexpectedError: 'Ocorreu um erro inesperado.',
    fileUploaded: 'Arquivo enviado com sucesso.',
    pexelsImage: 'Imagem do Pexels selecionada.',
    pexelsVideo: 'Vídeo do Pexels selecionado.',
    voiceSelection: 'Seleção de voz',
    regenerateAudio: 'Regenerar áudio',
    narrationPlaceholder: 'Digite o texto da narração...',
    narrationUpdated: 'Narração atualizada',
    audioRegenerated: 'Áudio regenerado com sucesso.',
    captionsUpdated: 'Legendas atualizadas',
    updateCaptions: 'Atualizar legendas',
    editCaptions: 'Editar legendas',
    mediaLibrary: 'Biblioteca de mídia',
    mediaLibraryHint: 'Pesquise no Pexels ou envie seus próprios arquivos.',
    aiTools: 'Ferramentas de IA',
    generateImage: 'Gerar imagem',
    generateImageHint: 'Descreva o que você imagina e nossa IA cria do zero.',
    prompt: 'Descrição',
    promptPlaceholder: 'Uma cena cinematográfica de uma cidade futurista ao pôr do sol...',
    generate: 'Gerar',
    uploadingAsset: 'Enviando arquivo...',
    generatingImage: 'Gerando imagem...',
  },

  premium: {
    title: 'Desbloqueie os recursos do Estúdio',
    body: 'Geração, edição e animação com IA estão disponíveis nos nossos planos premium.',
    viewPricing: 'Ver preços',
  },

  activity: {
    phases: {
      planning: 'Planejamento',
      concept: 'Desenvolvimento do conceito',
      storyboard: 'Storyboard e pesquisa',
      writing: 'Escrita do roteiro',
      voiceover: 'Geração de voz',
      visuals: 'Geração dos visuais',
      transcription: 'Transcrição',
      upload: 'Envio para a nuvem',
      finalizing: 'Finalização',
    },
    creating: 'Criando seu vídeo...',
    complete: 'Geração concluída!',
    remaining: 'Faltam ~{time}',
    almostDone: 'Quase lá…',
    processing: 'Processando...',
    messages: {
      gettingStarted: 'Começando',
      ready: 'Pronto',
      conceptReady: 'Conceito pronto',
      footageSelected: 'Material selecionado',
      finalizingScript: 'Finalizando o roteiro',
      scriptReady: 'Roteiro pronto',
      voiceovers: 'Gerando a narração de {n} cenas',
      voiceoversOne: 'Gerando a narração de {n} cena',
      allVoiceoversReady: 'Todas as narrações prontas',
      allVisualsReady: 'Todos os visuais prontos',
      visualsReady: 'Os {n} visuais estão prontos',
      visualsReadyOne: '{n} visual pronto',
      transcribing: 'Transcrevendo {n} faixas de áudio',
      transcribingOne: 'Transcrevendo {n} faixa de áudio',
      transcribed: '{n} faixas transcritas',
      transcribedOne: '{n} faixa transcrita',
      uploadingAssets: 'Enviando arquivos',
      scenesUploaded: '{n} cenas enviadas',
      scenesUploadedOne: '{n} cena enviada',
      sceneUploaded: 'Cena {n}/{total} enviada',
      wrappingUp: 'Últimos ajustes',
      videoReady: 'Seu vídeo está pronto',
      failed: 'Erro: {reason}',
      sceneNarration: 'Cena {n}: "{text}"',
      writingScript: 'Escrevendo o roteiro do seu vídeo',
      voiceoversAndVisuals: 'Gerando a narração e os visuais',
      transcribingAudio: 'Transcrevendo o áudio',
      finalizingVideo: 'Finalizando seu vídeo',
      calculatingDuration: 'Calculando a duração do vídeo',
      voiceoversComplete: 'Narração pronta, gerando os visuais',
      sceneVisualsReady: 'Visuais da cena {n} prontos',
      analyzingIdea: 'Analisando sua ideia',
      ideaExpanded: 'Ideia desenvolvida! Criando a estrutura do vídeo',
      polishingScript: 'Refinando e finalizando o roteiro',
      scriptComplete: 'Roteiro concluído! Preparando as cenas',
      searchingFootage: 'Buscando material que combine',
      findingClips: 'Encontrando os melhores clipes para o seu vídeo',
      curatingVisuals: 'Selecionando visuais extras',
      selectingFootage: 'Escolhendo o melhor material para cada cena',
      scriptAndFootageReady: 'Roteiro e material prontos',
      transcriptionComplete: 'Transcrição pronta',
      allAssetsUploaded: 'Todos os arquivos enviados',
      sceneLabel: 'Cena {n}',
      sceneVoiced: 'Cena {n} narrada',
    },
  },

  addSlide: {
    dialogTitle: 'Adicionar slide à cena {n}',
    title: 'Adicionar slide',
    added: 'Slide adicionado',
    addFailed: 'Falha ao adicionar o slide',
    addFailedBody: 'Não foi possível adicionar o slide.',
    uploaded: 'Slide enviado',
    generated: 'Slide gerado',
    generatedBody: 'Novo slide criado com IA.',
    limitBody: 'Você atingiu o limite de slides gerados neste projeto.',
  },

  asset: {
    dialogTitle: 'Editar slide - Cena {scene}, slide {slide}',
    studio: 'Estúdio',
    editSlide: 'Editar slide',
    invalidDuration: 'Duração inválida',
    invalidDurationBody: 'Use um número positivo.',
    durationUpdated: 'Duração atualizada',
    durationSet: 'Agora dura {n} s.',
    durationReset: 'Duração redefinida',
    durationResetBody: 'Voltou ao cálculo automático.',
    replaced: 'Mídia substituída',
    replaceFailed: 'Falha ao substituir',
    replaceFailedBody: 'Não foi possível substituir a mídia.',
    uploaded: 'Mídia enviada',
    regenerated: 'Slide regenerado',
    regeneratedBody: 'Nova imagem criada.',
    regenerateLimit: 'Você atingiu o limite de regenerações neste projeto.',
    edited: 'Slide editado',
    editedBody: 'Imagem atualizada com sucesso.',
    editLimit: 'Você atingiu o limite de edições neste projeto.',
    editFailed: 'Falha ao editar',
    animateLimit: 'Você atingiu o limite de animações neste projeto.',
    animationFailed: 'Falha na animação',
    editImage: 'Editar imagem',
    animateVideo: 'Animar em vídeo',
    editImageHint: 'Altere o slide atual com instruções em linguagem natural.',
    previewAlt: 'Prévia do slide atual',
    editingNote: 'Você está editando a imagem atual do slide. A IA vai manter a composição sempre que possível.',
    editInstructions: 'Instruções de edição',
    editPlaceholder: 'Deixe de noite, adicione chuva, mude a cor do carro...',
    applyEdits: 'Aplicar edições',
    animateTitle: 'Animar este slide',
    animateHint: 'Transforma a imagem num clipe de 5 segundos em movimento, no lugar dela.',
    animate: 'Animar',
    currentAsset: 'Mídia atual',
    assetAlt: 'Mídia atual do slide',
    badgeVideo: 'VÍDEO',
    badgeImage: 'IMAGEM',
    screenTime: 'Tempo na tela',
    auto: 'Auto',
    seconds: 'seg',
    set: 'Aplicar',
    autoSyncing: 'Sincronizando automaticamente com a narração ({n} s).',
    details: 'Detalhes',
    resolution: 'Resolução',
    ratio: 'Proporção',
    enhancingImage: 'Aprimorando imagem...',
    animatingVideo: 'Animando seu slide…',
    animatingWait: '{n} s · costuma levar de 15 a 40 segundos',
    animateAgain: 'Animar de novo',
    animateAgainTitle: 'Animar de novo',
    stillNote: 'Esta imagem vira o primeiro quadro do clipe. Depois você pode voltar para ela.',
    animatedNote: 'Este slide está animado. Teste outro movimento a partir da imagem ou volte para a imagem.',
    backToPicture: 'Voltar para a imagem',
    animateTime: 'Leva de 15 a 40 segundos.',
    animated: 'Slide animado',
    animatedBody: 'Já está rodando no seu vídeo. Não gostou? Teste outro movimento ou volte para a imagem.',
    restored: 'Voltou para a imagem',
    restoreFailed: 'Não deu para voltar para a imagem',
    restoring: 'Voltando para a imagem…',
  },

  animateAll: {
    animating: 'Animando slides',
    complete: 'Slides animados',
    stopped: 'Parado',
    noneWorked: 'Não deu para animar os slides',
    keepsGoing: 'Pode fechar: continua rodando, e cada slide muda no seu vídeo assim que fica pronto.',
    inProject: 'Os clipes novos já estão no seu vídeo. Abra um slide para testar outro movimento ou voltar para a imagem.',
    progress: '{current} de {total} animados',
    leftSeconds: 'faltam uns {n} s',
    leftMinutes: 'faltam uns {n} min',
    failed: '{n} não deram certo',
    stop: 'Parar',
    stopping: 'Parando depois deste…',
    hide: 'Ocultar',
    retry: 'Tentar {n} de novo',
    done: 'Pronto',
  },

  voiceConfirm: {

    paidOnly: 'Trocar a voz de um vídeo pronto é dos planos pagos. Você ainda pode escolher qualquer voz antes de gerar o próximo.',

    seePlans: 'Ver planos',
    seconds: '~{n} segundos',
    minuteOne: '~{n} minuto',
    minuteMany: '~{n} minutos',
    title: 'Trocar a voz de todas as cenas?',
    description: 'O áudio de todas as cenas será regenerado com a nova voz.',
    change: 'Troca de voz:',
    impactOne: 'O áudio de {n} cena será regenerado',
    impactMany: 'O áudio de {n} cenas será regenerado',
    creditsOne: 'Usa {n} crédito de regeneração de voz',
    creditsMany: 'Usa {n} créditos de regeneração de voz',
    time: 'Tempo estimado: {time}',
    canLeave: 'Acontece nos nossos servidores: você pode fechar a página',
    canUndo: 'Depois você pode voltar para a voz atual, sem custo',
    currentUsage: 'Uso atual:',
    afterChange: 'Depois desta troca:',
    remaining: 'Restam {n}',
    confirm: 'Confirmar e regenerar',
  },

  narration: {
    dialogTitle: 'Editar narração - Cena {n}',
    title: 'Editar narração',
    script: 'Roteiro',
    hint: 'Edite o texto abaixo para regenerar a narração.',
  },

  scene: {
    dialogTitle: 'Editor de cena - Cena {n}',
    title: 'Editor de cena',
    narrationTab: 'Narração e áudio',
    mobileTitle: 'Editar cena {n}',
    script: 'Roteiro da narração',
    hint: 'Edite o texto para regenerar a narração com IA.',
    voiceLimit: 'Você atingiu o limite de regenerações de voz neste projeto.',
    captionsBody: 'Tempos ajustados automaticamente.',
    timingTitle: 'Tempo das legendas',
    timingHint: 'Corrija erros de transcrição. O tempo é sincronizado automaticamente.',
    timingWarning: 'As mudanças aqui afetam a exibição das legendas. Para melhores resultados, mantenha a mesma quantidade de palavras.',
  },

  motion: {
    // How an animated slide moves (components/AIAgent/MotionPicker.jsx)
    label: 'Como deve se mexer?',
    picture: 'Pela imagem',
    pictureHint: 'Se mexe do jeito que a imagem foi descrita',
    subtle: 'Movimento sutil',
    subtleHint: 'A imagem ganha vida e a câmera fica parada',
    zoom: 'Zoom lento',
    zoomHint: 'A câmera se aproxima devagar do personagem',
    subject: 'O personagem se mexe',
    subjectHint: 'Pessoas e animais respiram, piscam e gesticulam',
    dramatic: 'Dramático',
    dramaticHint: 'Um grande movimento de câmera e muita ação',
    custom: 'Descreva você',
    customHint: 'Diga com suas palavras',
    customPlaceholder: 'Ex.: neve caindo devagar enquanto a lanterna pisca',
  },

  slides: {
    title: 'Animar slides',
    subtitle: 'Escolha as imagens que vão virar clipes curtos em movimento. Cada uma leva uns 20 segundos.',
    pick: 'Imagens para animar',
    picked: '{selected} de {total} escolhidas',
    selectAll: 'Escolher todas',
    clear: 'Limpar seleção',
    left: 'Restam {remaining} de {limit} animações neste projeto',
    noneLeft: 'Você já usou todas as animações deste projeto.',
    upgrade: 'Fazer upgrade',
    allMoving: 'Todos os slides deste vídeo já se mexem.',
    movingOne: '{n} slide já se mexe (um clipe de vídeo ou uma animação), então não aparece aqui.',
    movingMany: '{n} slides já se mexem (clipes de vídeo ou animações), então não aparecem aqui.',
    underMinute: 'Menos de um minuto',
    aboutMinutes: 'Uns {n} min',
    pickFirst: 'Escolha os slides',
    animateOne: 'Animar {n} slide',
    animateMany: 'Animar {n} slides',
    thumbAlt: 'Cena {scene} - Slide {slide}',
  },

  captionsEdit: {
    confirm: 'Há mudanças grandes e o tempo das legendas pode ser afetado. Deseja continuar?',
    updatedBody: 'O tempo foi ajustado automaticamente.',
    dialogTitle: 'Editar legendas - Cena {n}',
    subtitle: 'Cena {n} • Sincroniza com o áudio',
    warning: 'Ao editar o texto aqui, o tempo das legendas é realinhado automaticamente. Tente manter uma quantidade parecida de palavras para preservar o ritmo.',
    placeholder: 'Digite o texto das legendas...',
    words: '{n} palavras',
    autoSync: 'Sincronização automática ativada',
  },

  voicePicker: {
    title: 'Escolha a voz do narrador',
    description: 'Escolha uma voz para a narração do seu vídeo',
    confirm: 'Confirmar',
  },

  captionStyle: {
    previewYour: 'Sua',
    previewStory: 'história',
    templates: {
      keyword: 'Palavra-chave',
      minimal: 'Minimal',
      neon: 'Neon',
      tiktok: 'TikTok',
      comic: 'Gibi',
      elegant: 'Elegante',
      glitch: 'Glitch',
      bold: 'Negrito',
      clean: 'Limpo',
      outline: 'Contorno',
      punch: 'Impacto',
      redbox: 'Caixa vermelha',
      boxed: 'Em caixa',
      podcast: 'Podcast',
      pop: 'Pop',
      mint: 'Menta',
    },
    position: 'Posição',
    fontText: 'Fonte e texto',
    colors: 'Cores',
    text: 'Texto',
    highlight: 'Destaque',
    stroke: 'Contorno',
    background: 'Fundo',
    animationTiming: 'Animação e ritmo',
    speed: 'Ritmo',
    speedAria: 'Velocidade de agrupamento de palavras',
    words: 'Palavras',
    wordsAria: 'Máximo de palavras por página',
    spacing: 'Espaçamento',
    lineHeight: 'Entrelinhas',
    letterSpacing: 'Entre letras',
    transforms: 'Transformações',
    rotation: 'Rotação',
    skew: 'Inclinação',
    scale: 'Escala',
  },

  // A busca do Pexels e o envio de arquivos dos diálogos de cena
  mediaPicker: {
    searchTab: 'Buscar no Pexels',
    uploadTab: 'Enviar um arquivo',
    images: 'Imagens',
    videos: 'Vídeos',
    searchImages: 'Buscar imagens…',
    searchVideos: 'Buscar vídeos…',
    search: 'Buscar',
    orientation: 'Orientação',
    anyOrientation: 'Qualquer orientação',
    landscape: 'Horizontal',
    portrait: 'Vertical',
    square: 'Quadrada',
    size: 'Tamanho',
    anySize: 'Qualquer tamanho',
    small: 'Pequeno',
    medium: 'Médio',
    large: 'Grande',
    foundImages: '{count} imagens encontradas',
    foundVideos: '{count} vídeos encontrados',
    page: 'Página {page}',
    previousPage: 'Página anterior',
    nextPage: 'Próxima página',
    promptImagesTitle: 'Busque imagens',
    promptVideosTitle: 'Busque vídeos',
    promptImagesBody: 'Digite acima o que você precisa para achar imagens grátis no Pexels.',
    promptVideosBody: 'Digite acima o que você precisa para achar vídeos grátis no Pexels.',
    noImages: 'Nenhuma imagem para “{query}”',
    noVideos: 'Nenhum vídeo para “{query}”',
    select: 'Escolher',
    photoBy: 'Foto de {name}',
    videoBy: 'Vídeo de {name}',
    by: 'de {name}',
    poweredBy: 'Com tecnologia',
    uploadTitle: 'Envie o seu',
    uploadImage: 'Escolha uma imagem do seu aparelho.',
    uploadVideo: 'Escolha um vídeo do seu aparelho.',
    uploadBoth: 'Escolha uma imagem ou um vídeo do seu aparelho.',
    chooseFile: 'Escolher arquivo',
    previewImage: 'Prévia da imagem',
    previewVideo: 'Prévia do vídeo',
    close: 'Fechar',
    cancel: 'Cancelar',
    addImage: 'Usar esta imagem',
    addVideo: 'Usar este vídeo',
    loadFailedTitle: 'Não deu para carregar os resultados',
    loadFailedBody: 'O Pexels não respondeu. Tente de novo daqui a pouco.',
    wrongTypeTitle: 'Esse arquivo não serve aqui',
    wrongTypeImage: 'Escolha um arquivo de imagem.',
    wrongTypeVideo: 'Escolha um arquivo de vídeo.',
    wrongTypeBoth: 'Escolha uma imagem ou um vídeo.',
  },
};
